/**
 * File picker for "upload proof now" on create forms; files are uploaded and linked
 * to the record after it has been saved.
 */
import type { AttachableType } from "@shared/constants.ts";
import { Form } from "react-bootstrap";
import { api } from "../../lib/api.ts";

export function AttachOnSave({
  files,
  onChange,
  label = "Attach evidence (optional)",
  hint,
}: {
  files: File[];
  onChange: (files: File[]) => void;
  label?: string;
  hint?: string;
}) {
  return (
    <Form.Group className="mb-3" controlId="attach-on-save">
      <Form.Label>{label}</Form.Label>
      <Form.Control
        type="file"
        multiple
        accept=".pdf,.jpg,.jpeg,.png,.webp,.heic,.txt,.csv,.doc,.docx,.xls,.xlsx,.odt,.ods"
        onChange={(e) => onChange(Array.from((e.target as HTMLInputElement).files ?? []))}
      />
      <Form.Text className="text-muted">
        {hint ?? "Receipts, invoices, statements or photos. PDF, images or Office documents."}
        {files.length > 0 && ` ${files.length} file(s) selected.`}
      </Form.Text>
    </Form.Group>
  );
}

export async function uploadAll(
  files: File[],
  entityType: AttachableType,
  entityId: string,
  category: string,
) {
  for (const file of files) {
    const form = new FormData();
    form.append("file", file);
    form.append("entityType", entityType);
    form.append("entityId", entityId);
    form.append("category", category);
    await api.upload("/api/documents", form);
  }
}
